<template>
  <router-view />
</template>

<script>
export default {
  name: 'points-page-container',
};
</script>
